import { Navigate, useParams } from 'react-router';
import { sectionPath } from './place';

/**
 * `/admin/tenants/:tenantId` was today's operator page for one tenant, with its organizations
 * (FR-AD-12). It now leads to that tenant's Organizzazioni, so an old link or bookmark still lands
 * where it meant to.
 */
export function OldTenantRedirect() {
  const { tenantId = '' } = useParams();
  return <Navigate to={sectionPath({ kind: 'tenant', id: tenantId }, 'organizations')} replace />;
}
